export default class LicenseInUseError extends Error {}
